export const state = {
  invoices: [],
  invoices_pagination: null,
  companies: [],
  companies_pagination: null,
  statistics: null
}
